"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassesPropType = void 0;

var _propTypes = require("prop-types");

var getClassesPropType = function getClassesPropType(cssModule) {
  return (0, _propTypes.shape)(Object.keys(cssModule).reduce(function (res, key) {
    res[key] = _propTypes.string;
    return res;
  }, {}));
};

exports.getClassesPropType = getClassesPropType;